export default __webpack_public_path__ + "static/media/J_wdt_c_cap_0.e0640f06.mp3";